import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';
import { DestinationsService } from '../../reducers/services/destinations.service';

@Injectable({ providedIn: 'root' })
export class DiningRouteDecisionResolver implements Resolve<any> {
  constructor(private destinationService: DestinationsService) {}

  async resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<any> {
    try {
      const url = state.url;
      const slug = url.substring(url.lastIndexOf('/') + 1);
      return await this.checkRouteAndNavigate(slug, url);
    } catch (err) {
      console.error(err);
      return { type: '404' };
    }
  }

  private getDestinationBySlugPromise(slug: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.destinationService.getDestinationBySlug(slug).subscribe({
        next: resolve,
        error: reject,
      });
    });
  }

  private getDiningBySlugPromise(slug: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.destinationService.getDiningDescriptionData(slug).subscribe({
        next: resolve,
        error: reject,
      });
    });
  }

  private async checkRouteAndNavigate(slug: string, url: string): Promise<any> {
    if (slug && url.includes('restaurant')) {
      if (slug === 'all') {
        return { type: 'destination', data: 'all' };
      } else {
        try {
          const destinationData = await this.getDestinationBySlugPromise(slug);
          if (destinationData?._id) {
            return { type: 'destination', data: destinationData };
          }
        } catch {
          try {
            const diningData = await this.getDiningBySlugPromise(slug);
            if (diningData?._id) {
              return { type: 'restaurant', data: diningData };
            }
          } catch {
            console.log('error not found restaurant');
            return { type: '404' };
          }
        }
      }
      return { type: '404' };
    }
  }
}
